export default __webpack_public_path__ + "static/media/B193.6669b768.png";